(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-entry-portal"] && !Shopify.designMode) return;
  try {
    
(function(){function initEntryPortal(portal){if(!portal||portal.dataset.initialized==='true')return;portal.dataset.initialized='true';var params=new URLSearchParams(window.location.search);var forcePortal=params.has('cc_portal');var showOnce=portal.dataset.showOnce==='true';var storageKey=portal.dataset.storageKey||'cc-entry-portal-v1';var redirectUrl=portal.dataset.redirectUrl||'/pages/about-us';try{if(showOnce&&!forcePortal&&window.sessionStorage.getItem(storageKey)==='entered'){portal.remove();return}}catch(error){showOnce=false}var step=0;var count=portal.querySelector('[data-cc-entry-count]');document.documentElement.classList.add('cc-entry-portal-lock');window.requestAnimationFrame(function(){portal.classList.add('is-ready')});function updateStep(nextStep){step=Math.min(nextStep,3);portal.classList.remove('is-step-1','is-step-2','is-step-3');portal.classList.add('is-step-'+step);if(count)count.textContent=step+' / 3'}function enterAbout(){portal.classList.add('is-entering');try{if(showOnce)window.sessionStorage.setItem(storageKey,'entered')}catch(error){}window.setTimeout(function(){portal.classList.add('is-hidden');document.documentElement.classList.remove('cc-entry-portal-lock')},980);window.setTimeout(function(){window.location.href=redirectUrl},1250)}function advance(event){if(event)event.preventDefault();if(portal.classList.contains('is-entering'))return;updateStep(step+1);if(step>=3)enterAbout()}portal.addEventListener('click',advance);portal.addEventListener('keydown',function(event){if(event.key==='Enter'||event.key===' ')advance(event)})}function initAllEntryPortals(){document.querySelectorAll('[data-cc-entry-portal]').forEach(initEntryPortal)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAllEntryPortals)}else{initAllEntryPortals()}document.addEventListener('shopify:section:load',function(event){initEntryPortal(event.target.querySelector('[data-cc-entry-portal]'))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
